import React from "react";
import * as Util from "./util";

export const overlay = (text, color, a, j, font = 64) => {
    return rawOverlay(<p
        style={{textAlign: "center", fontSize: font, fontWeight: 400, color: color}}>{text}</p>, color, a, j);
};


export const rawOverlay = (text, color, a, j) => {
    let align = a || "center";
    let justify = j || "center";
    return (
        <div style={{
            position: "absolute",
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: align,
            justifyContent: justify,
            zIndex: 10000
        }}>
            {text}
        </div>
    );
};

export const freeFormOverlay = (content, a, j) => {
    let align = a || "center";
    let justify = j || "center";
    return (
        <div style={{
            position: "absolute",
            left: 0,
            top: 0,
            display: "flex",
            alignItems: align,
            justifyContent: justify,
            zIndex: 10000
        }}>
            {content}
        </div>
    );
};

export const iff = (cond) => {
    return cond ? "" : "none";
};

export const gsmImage = (gsm, type) => {
    let src = Util.getGsmIcon(gsm);
    return <img
        style={{verticalAlign: "middle"}}
        src={require("../../assets/" + src + type + ".png")}/>;
};

export const image = (src, size) => {
    return <img
        style={{verticalAlign: "middle", width: size, height: size}}
        src={require("../../assets/" + src + ".png")}/>;
};